<template>
  <SubdistributorList :distributor_id="distributor_id"/>
</template>

<script>
import SubdistributorList from '@/components/SubdistributorList';

export default {
  name: 'SubdistributorsTab',
  props: ['distributor_id'],
  components: {
    SubdistributorList,
  },
};
</script>
